import React, { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import MuxPlayer from "@mux/mux-player-react";

interface VideoOverlayProps {
  playbackId: string;
  onClose: () => void;
}

const VideoOverlay: React.FC<VideoOverlayProps> = ({ playbackId, onClose }) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };

  return (
    <div
      ref={overlayRef}
      className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 md:p-8"
      onClick={handleOverlayClick}
    >
      <div className="relative w-full max-w-4xl bg-black rounded-lg overflow-hidden">
        <Button
          onClick={onClose}
          variant="ghost"
          size="icon"
          className="absolute top-2 right-2 z-10 text-white bg-black/50 hover:bg-black/70 rounded-full"
        >
          <X size={24} />
        </Button>

        <MuxPlayer
          playbackId={playbackId}
          metadata={{
            video_title: "28X App Preview",
            viewer_user_id: "anonymous",
          }}
          streamType="on-demand"
          autoPlay
          style={{ height: "100%", width: "100%", aspectRatio: "16/9" }}
        />
      </div>
    </div>
  );
};

export default VideoOverlay;
